import baseAPI from '@/http'

const router = 'api/sala5w2h'

export const Sala5w2hAPI = {
  create: (data) => baseAPI.post(router + '/cadastrar-5w2h', data),
  update: (data) => baseAPI.put(router + '/atualizar-5w2h', data),
  getbyMunicipio: (id) => baseAPI.get(`${router}/obter-5w2h-por-municipio/${id}`),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  get: (id) => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(router)

}
